import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-dialog-info-capacita-spesa-dichiarazione',
  templateUrl: './dialog-info-capacita-spesa-dichiarazione.component.html',
  styleUrls: ['./dialog-info-capacita-spesa-dichiarazione.component.css']
})
export class DialogInfoCapacitaSpesaDichiarazione {

  constructor(public dialogRef: MatDialogRef<DialogInfoCapacitaSpesaDichiarazione>) { }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-info-capacita-spesa-dichiarazione/dialog-info-capacita-spesa-dichiarazione.component.ts